// extracted by mini-css-extract-plugin
module.exports = {"feedback-buttons":"feedback-buttons--2Igb5NjA"};